import Vue from 'vue'
import Vuex from 'vuex'
import { make, set, dispatch } from 'vuex-pathify'
import pathify from 'vuex-pathify'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

pathify.options.mapping = 'standard'
pathify.options.deep = 2

const state = {
  user: null,
  token: null,
  organisation: null
}

export default new Vuex.Store({
  state,
  mutations: {
    ...make.mutations(state),
  },
  actions: {
    async logOut({ commit, state }) {
      let response = await this._vm.$areYouSure("Exit?")
      if (response) {
        let logout = await this._vm.$firebase.auth().signOut()
        commit("SET_USER", null)
      }
    },
    async retrieveUser({ commit }) {
      let currentUser = this._vm.$firebase.auth().currentUser
      const token = await currentUser.getIdToken()
      await commit("SET_USER", {
        uid: currentUser.uid,
        photoURL: currentUser.photoURL || "",
        email: currentUser.email || "",
        telephone: currentUser.phoneNumber || "",
        name: currentUser.displayName || "",
        lastName: "",
        token,
      })
      this._vm.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    },
    async createOrganisation({commit, state}, payload) {
      const organisation = {
        organisationName: payload.organisationName,
        dbConnection: payload
      }
      const orgRes = await this._vm.$axios.post('organisation', organisation);
      const orgId = orgRes.data._id;
      await this._vm.$axios.get(`organisation/create_container/${orgId}`);

    },
    async getOrganisation({commit}) {
      const orgRes = await this._vm.$axios.get('organisation')
      await this._vm.$axios.get('organisation/set_port', {withCredentials: true})
      commit("SET_ORGANISATION", orgRes.data)
    },
    testConnection({}, connection) {
      return this._vm.$axios.post('organisation/test_connection', connection)
    }
  },

  modules: {
  },

  plugins: [
    pathify.plugin,
    createPersistedState({
      paths: []
    })
  ],
})
